var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 40.36 40.36",
    height: 512,
    viewBox: "0 0 40.36 40.36",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Hjerte_m_puls"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.36 13.508c0 .26-.01.52-.03.78-.01.38-.07.77-.13 1.14-.04.24-.08.47-.14.7-.06.27-.13.54-.21.81 0 .01-.01.02-.01.03-.26.87-.63 1.71-1.1 2.49h-5.14l-3.39-6.31-5.16 10.23-6.34-14.37-5.5 10.45h-5.09c-1.31.03-1.31 1.97 0 2h6.3l4.13-7.86 6.38 14.47 5.33-10.59 2.14 3.98h4.85c-.1.12-17.1 17.13-17.1 17.13l-16.73-16.72c-4.56-4.35-4.56-12.25 0-16.6 4.43-4.63 12.32-4.52 16.73.07 7.32-7.52 20.22-2.36 20.21 8.17z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.a31f693334a20d3b252b9a515d6c04f2.svg";
export { ForwardRef as ReactComponent };